const FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

export function formatDate(
  value: string | Date | null | undefined,
  fallback: string | null = '—'
): string {
  if (!value) return fallback ?? '';
  return new Date(value).toLocaleDateString(undefined, FORMAT_OPTIONS);
}
